import { Reaction, ReactionSummary } from "types/Post";

export const REACTION_EMOJI: Record<Reaction, string> = {
  like: "👍",
  celebrate: "🎉",
  love: "❤️",
};

/** i18n key of each reaction's name; the pills use it as their screen-reader label. */
export const REACTION_NAME_KEYS: Record<Reaction, string> = {
  like: "news_reaction_like",
  celebrate: "news_reaction_celebrate",
  love: "news_reaction_love",
};

/** The reactions as they will be once the viewer has pressed this one: given if they had not, taken back if they had. */
export const withReactionToggled = (reactions: ReactionSummary[], reaction: Reaction): ReactionSummary[] =>
  reactions.map((summary) =>
    summary.reaction !== reaction
      ? summary
      : { ...summary, reactedByMe: !summary.reactedByMe, count: summary.count + (summary.reactedByMe ? -1 : 1) }
  );

interface OptimisticToggle {
  /** The reactions on screen now. */
  current: ReactionSummary[];
  reaction: Reaction;
  /** Puts these reactions on screen. */
  show: (reactions: ReactionSummary[]) => void;
  /** Sends the reaction to the server; answers with the reactions the server now has. */
  send: () => Promise<ReactionSummary[]>;
}

/**
 * Shows the pressed reaction at once, then replaces that guess with the server's answer. If the request
 * fails the old reactions come back and the error goes on to the caller, who tells the viewer.
 */
export async function toggleReactionOptimistically({ current, reaction, show, send }: OptimisticToggle) {
  show(withReactionToggled(current, reaction));
  try {
    show(await send());
  } catch (error) {
    show(current);
    throw error;
  }
}
